import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Image from '@base/Image';
import useCertificationCourseData from './useCertificationCourseData';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
`;

const Title = styled(Typography)``;

const ImageWrapper = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
`;

const SubContainer = styled.div`
  padding: 24px;
  height: 174px;
  background: #ffffff;
  border: ${Spacings.SPACING_1} solid #e9eef2;
  border-radius: ${Spacings.SPACING_2B};
  display: flex;
  gap: ${Spacings.SPACING_6B};
  flex-direction: column;
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B};
    height: auto;
  }
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
`;

const PaymentInfoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    gap: ${Spacings.SPACING_4B};
  }
`;

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_2B};
  min-width: 174px;
`;

const RightContainer = styled.div`
  gap: ${Spacings.SPACING_2B};
  display: grid;
`;

const Text = styled(Typography)`
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.ULTRA_SMALL};
    line-height: ${Spacings.SPACING_4B};
  }
`;

const EmiPrice = styled(Typography)`
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
    line-height: ${Spacings.SPACING_5B};
  }
`;

const NoConstEmi = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
`;

const PaymentMethods = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
`;

const CourseFees = ({ goalUID }) => {
  const { sections } = useCertificationCourseData(goalUID);
  const courseFee = sections?.courseFee ?? {};
  return (
    <Container>
      <Title variant="h3">
        {courseFee.programmeCourseFeeTitle || 'Course fees'}
      </Title>
      <SubContainer>
        <PriceContainer>
          <Title variant="h4">{courseFee.programmeTotalAmount}</Title>
          <Text variant="p2" color="var(--color-text-secondary)">
            (Incl. of taxes)
          </Text>
        </PriceContainer>
        <PaymentInfoContainer>
          <LeftContainer>
            <Text variant="p2" color="var(--color-text-secondary)">
              {courseFee.emiStartsFromLabel}
            </Text>
            <EmiPrice variant="h5">{courseFee.programmeEmiTenure}</EmiPrice>
            {courseFee.isNoCostEmiAvailable && (
              <NoConstEmi>
                <ImageWrapper>
                  <Image
                    src="certificationCourses/wallet.svg"
                    layout="fill"
                    alt="printed-notes"
                  />
                </ImageWrapper>
                <Text variant="p3" color="var(--color-text-primary)">
                  No cost EMI also available
                </Text>
              </NoConstEmi>
            )}
          </LeftContainer>
          <RightContainer>
            <Text variant="p2" color="var(--color-text-secondary)">
              {courseFee.paymentModesLabel}
            </Text>
            <PaymentMethods>
              {courseFee?.paymentModesIcons?.map((paymentModesIcon) => {
                return (
                  <ImageWrapper key={paymentModesIcon.uid}>
                    <Image
                      src={paymentModesIcon.imageSrc}
                      layout="fill"
                      alt="printed-notes"
                    />
                  </ImageWrapper>
                );
              })}
            </PaymentMethods>
          </RightContainer>
        </PaymentInfoContainer>
      </SubContainer>
    </Container>
  );
};

export default CourseFees;
